import { classPath } from '@/app/routes/paths';

/** Public URL used in QR codes and “Share class link”. */
export function buildClassShareUrl(classCode: string): string {
  if (typeof window === 'undefined') {
    return classPath(classCode);
  }
  return `${window.location.origin}${classPath(classCode)}`;
}
